import React, {
  RefObject,
} from 'react';
import {
  InformationCard,
} from 'views/EMR/components/PCC/Walkthrough/components/ContentPrimitives';
import PageIntroduction from 'views/EMR/components/PCC/Walkthrough/components/PageIntroduction';
import type {
  InformationPageDefinition,
} from 'views/EMR/components/PCC/Walkthrough/types';

type Props = {
  page: InformationPageDefinition;
  headingRef: RefObject<HTMLHeadingElement | null>;
};

export default function InformationPage({
  page,
  headingRef,
}: Props) {
  return (
    <div className="flex flex-col gap-5">
      <PageIntroduction
        eyebrow={page.introduction.eyebrow}
        heading={page.introduction.heading}
        description={page.introduction.description}
        headingRef={headingRef}
      />

      <div className="grid grid-cols-1 gap-3.5 sm:grid-cols-2 xl:grid-cols-4">
        {page.items.map((item) => (
          <InformationCard
            key={item.title}
            title={item.title}
            description={item.description}
            iconKey={item.iconKey}
          />
        ))}
      </div>
    </div>
  );
}
